module.exports = __webpack_public_path__ + "static/media/8.e951e098.jpg";